import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Skeleton } from '@mui/material';

interface OutlinedCardProps {
  nome: string;
  valor: number;
  cor: string;
  img: string;
  loading?: boolean;
}

const OutlinedCard2: React.FC<OutlinedCardProps> = ({ nome, valor, cor, img, loading }) => {
  return (
    <Box sx={{ margin: 1 }}>
      <Card variant="outlined" sx={{ borderRadius: '8px' }}>
        <CardContent style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '8px', display: 'flex' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '3px', backgroundColor: cor }} sx={{ width: '0.1px', height: '100px' }} />
          </Box>
          <Box sx={{ flex: '1 0 auto', margin: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography sx={{ fontSize: 25, flexGrow: 1 }} >
                {nome}
              </Typography>
              {(img != '') && (
                <img src={img} alt="Cadastro" style={{ width: '35px', height: '35px'}} />
              )}
            </Box>
            <Typography sx={{ fontSize: 40, textAlign: 'right' }} color="text.secondary">
              {loading ? <Skeleton variant="text" /> : valor}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OutlinedCard2;
